function hasUncheckedCheckbox (checkboxes) {
	for (var i = 0; i < checkboxes.length; i++) {
		if (!checkboxes[i].checked) {
			return true
		}
	}
	return false
}

export default hasUncheckedCheckbox

hasUncheckedCheckbox.__filename__ = 'components/has-unchecked-checkbox.js'
